import { AuthService } from './auth/auth.service';
import { Component, OnInit } from "@angular/core";
import { Router, NavigationEnd, NavigationCancel, NavigationStart } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { GeneralService } from "./services/general.service";
import { SignupLoginService } from "./services/signupLogin.service";
import * as socketIo from 'socket.io-client'
import { Store } from '@ngrx/store';
import { AppState } from './store/app.state';
import { SystemActivities } from './services/system-analysis.service';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import $ from 'jquery';

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {

  title = "notch-angular";
  signUpLoginView = true;
  org;
  userID;
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
  origin = window.location.origin;
  pathname = window.location.pathname;

  constructor(
    private router: Router,
    public gs: GeneralService,
    private authSrv: AuthService,
    private signupSrv: SignupLoginService,
    public analysis: SystemActivities,
    private idle: Idle,
    private keepalive: Keepalive,
    private store: Store<AppState>,
  ) {
    store.select("userInfo").subscribe(info => {
      if (info && info.user && info.organization) {
        this.org = info.organization;
        this.userID = info.user.id;
      }
    });
  }

  ngOnInit() {
    this.router.events.forEach(event => {
      if (event instanceof NavigationStart) {
        const modulex = event.url.split('/')[1]
        this.gs.displaySpinner(modulex)
        if (this.userID) {
          this.notchActivity(event.url);
        }
      }
      if (event instanceof NavigationCancel) {
        this.gs.showSpinner.next(false);
      }
      if (event instanceof NavigationEnd) {
        this.gs.showSpinner.next(false);
        if (this.gs.getSubmenEl) {
          this.gs.getSubmenEl.classList.add('d-none')
        }
        const body = $("html, body");
        body.stop().animate({ scrollTop: 0 }, 500, 'swing');
      }
    })
    // Prevent Inactivity logout on Demo-
    if (this.origin !== 'https://demo.notchcx.io' && this.origin !== 'http://localhost:1100') {
      setTimeout(() => {
        this.inActivity();
      }, 10000);
      // Start license expiry watcher on app initialization
      this.signupSrv.startLicenseExpiryWatcher();
    }
  }

  // Notch User/Org. Activities
  notchActivity(router) {
    const xTitle = router
    const url = `${window.location.origin}${router}`
    const payload = {
      createdDate: "string",
      createdTime: 0,
      id: this.userID,
      orgID: this.org.id,
      title: xTitle,
      url: url,
      userID: this.userID
    };
    this.analysis.newActivity(payload).subscribe(data => { })
  }

  inActivity() {
    this.idle.setIdle(1800);
    //  this.idle.setTimeout(30);
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.onIdleEnd.subscribe(() => {
      this.idleState = 'No longer this.idle.'
      this.reset();
    });

    const userData = localStorage.getItem("User");
    if(!userData){
      this.idle.onTimeout.subscribe(() => {
        this.idleState = 'Timed out!';
        this.timedOut = true;
        document.getElementById('closeTimoutModal').click()
        this.authSrv.logout()
        this.router.navigate(['/login'], { queryParams: { showTimeoutModal: true } }).then(() => {
          window.location.reload();
        });
      });
    }

    this.idle.onIdleStart.subscribe(() => {
      this.idleState = 'You\'ve gone idle!'
      //  document.getElementById('openTimeoutModal').click()
    });

    //  this.idle.onTimeoutWarning.subscribe((countdown) => {
    //    this.idleState = 'You will time out in ' + countdown + ' seconds!'
    //  });

    this.keepalive.interval(15);

    this.keepalive.onPing.subscribe(() => this.lastPing = new Date());
    this.store.select("userInfo").subscribe(info => {
      if (info && info.token && info.token !== null) {
        this.idle.watch()
        this.timedOut = false;
      } else {
        this.idle.stop();
      }
    });

    //  this.reset();
  }

  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }

  stay() {
    this.reset();
    document.getElementById('closeTimoutModal').click()
  }

}
